import { render } from "./Gizi.vue?vue&type=template&id=3a081f26&scoped=true"
import script from "./Gizi.vue?vue&type=script&lang=js"
export * from "./Gizi.vue?vue&type=script&lang=js"

import "./Gizi.vue?vue&type=style&index=0&id=3a081f26&scoped=true&lang=css"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a081f26"]])

export default __exports__